var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-page-container",attrs:{"id":"banner"}},[_c('div',{staticClass:"register-form-container"},[_c('jt-register-form',{staticClass:"register-form",attrs:{"id":"registerform","game":_vm.game,"tag":_vm.tag,"errMessage":_vm.errMessage,"zhuti":_vm.zhuti},on:{"signup":_vm.register}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }